var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0057 17.7044C16.4086 18.1024 15.7151 18.3129 15 18.3129C14.285 18.3129 13.5914 18.1024 12.9943 17.7044L3.1598 11.1478C3.10523 11.1115 3.05208 11.0735 3 11.0345V21.7781C3 23.0099 3.99961 23.9875 5.20936 23.9875H24.7906C26.0224 23.9875 27 22.9879 27 21.7781V11.0345C26.9478 11.0736 26.8945 11.1116 26.8398 11.148L17.0057 17.7044Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93984 9.97773L13.7744 16.5343C14.1466 16.7825 14.5733 16.9066 15 16.9066C15.4267 16.9066 15.8534 16.7825 16.2256 16.5343L26.0602 9.97773C26.6487 9.58562 27 8.92937 27 8.22109C27 7.00323 26.0092 6.01248 24.7914 6.01248H5.20861C3.9908 6.01253 3 7.00328 3 8.22226C3 8.92937 3.35137 9.58562 3.93984 9.97773Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5fa8815a8e355ad908c90c05bc45b3f6.svg";
export { ForwardRef as ReactComponent };